// @ts-ignore not converted yet
import { reportError } from 'ContentUtils/helpers/sentry';
import { PlayerTypes } from 'video-embed/types';
import { isAuthedAppPreview } from 'video-embed/utils/env';
import { fetchCaptionUrls } from 'video-data-lib/api/captions';
import { FETCH_CAPTION_URLS_ATTEMPTED, FETCH_CAPTION_URLS_FAILED, FETCH_CAPTION_URLS_SUCCEEDED } from './ActionTypes';
import { translateTrackLanguageCode } from '../utils/I18n';
const PUBLIC_CAPTIONS_PLAYER_TYPES = [PlayerTypes.ACADEMY_IN_APP, PlayerTypes.ACADEMY_EMBEDDED, PlayerTypes.FLOATING_PLAYER];
const shouldFetchSignedCaptions = ({
  playerType
}) => isAuthedAppPreview() && !(playerType && PUBLIC_CAPTIONS_PLAYER_TYPES.includes(playerType));
export const loadCaptions = (videoId, context = {}) => dispatch => {
  dispatch({
    type: FETCH_CAPTION_URLS_ATTEMPTED
  });
  return fetchCaptionUrls(videoId, shouldFetchSignedCaptions(context)).then(resp => {
    const captions = Object.keys(resp).map(lang => ({
      lang,
      label: translateTrackLanguageCode(lang),
      url: resp[lang]
    })).sort((a, b) => a.label.localeCompare(b.label));
    dispatch({
      type: FETCH_CAPTION_URLS_SUCCEEDED,
      captions
    });
  }).catch(err => {
    reportError(err, {
      errorId: FETCH_CAPTION_URLS_FAILED
    });
    dispatch({
      type: FETCH_CAPTION_URLS_FAILED
    });
    throw err;
  });
};